import {useEffect, useState} from 'react';
import {useFetchGetData, useFetchPostData} from './useFetchData'
import {useQueryParams} from './useLocationData'
import recipesMapping from '../data/mapping/pages/recipesMapping';
import recipesPageMapping from '../data/mapping/pages/recipesPageMapping';
import recipesMockData from '../data/recipes.json';

const useRecipesData = (pageNumber, pageType) => {
  const queryKey = 'recipesData' + pageNumber;
  let recipesQueryPath = '/jsonapi/views/recipe_list_component/recipe_list_component?page=' + pageNumber;

  if (pageType === 'promotions') {
    recipesQueryPath = '/jsonapi/views/promotion_list_component/promotion_list_component?page=' + pageNumber;
  }

  const queryParams = useQueryParams();
  const isMockData = queryParams.get('useMockData') === 'true';
  const [recipesQueryData, setRecipesQueryData] = useState('');
  const { isLoading, error, data } = useFetchGetData(queryKey, recipesQueryPath, isMockData);

  useEffect(() => {
    if (data && !isMockData) {
      const mappedData = recipesMapping(data, pageType);
      setRecipesQueryData(mappedData);
    }
  }, [data, isMockData, pageType])

  if (isMockData) {
    return {
      error: false,
      isLoading: false,
      recipesQueryData: recipesMockData
    };
  }

  return  {
    error,
    isLoading,
    recipesQueryData
  };
}

const useRecipesPageData = (pagePath) => {
  const queryKey = 'recipesPageData' + pagePath;
  const queryParams = useQueryParams();
  const isMockData = queryParams.get('useMockData') === 'true';
  const [recipesPageQueryData, setRecipesPageQueryData] = useState('');
  const { recipesIsLoading, recipesError, data } = useFetchPostData(queryKey, pagePath, isMockData);

  useEffect(() => {
    if (data && !isMockData) {
      const mappedData = recipesPageMapping(data);
      setRecipesPageQueryData(mappedData);
    }
  }, [data, isMockData])

  if (isMockData) {
    return {
      recipesError: false,
      recipesIsLoading: false,
      recipesPageQueryData: recipesMockData
    };
  }

  return  {
    recipesError,
    recipesIsLoading,
    recipesPageQueryData
  };
}

export  { useRecipesPageData, useRecipesData };
